import React, { useReducer, useEffect } from "react";

import { validate } from "../../util/validators";

import "./Input.css";

const Input = (props) => {

  const initialFormState = {
    value: props.initialValue || "",
    isValid: props.initialValid || false,
    isTouched: false,
    hasTyped: false,
  };

  const inputReducer = (state, action) => {
    switch (action.type) {
      case "CHANGE":
        return {
          ...state,
          value: action.payload,
          isValid: validate(action.payload, action.validators),
          hasTyped: true,
        };
      case "TOUCH":
        return { ...state, isTouched: true };
      default:
        return state;
    }
  };

  const [inputState, dispatch] = useReducer(inputReducer, initialFormState);
  
  const { id, onInput } = props;
  const { value, isValid, isTouched, hasTyped } = inputState;
  const showError = !isValid && isTouched && hasTyped;

  useEffect( () => {
    onInput(id, value, isValid)
  }, [id, value, isValid, onInput]);

  const changeHandler = (event) => {

    let value;
    if (props.type === "number") {
      value = event.target.valueAsNumber;
      if (isNaN(value)) {
        value = ""; // Handle empty or invalid number inputs
      }
    } else {
      value = event.target.value;
    }

    dispatch({
      type: "CHANGE",
      payload: value,
      validators: props.validators,
    });
  };

  const touchHandler = () => {
    dispatch({ type: "TOUCH" });
  };

  const messageId = `${props.id}-msg`;
  const hasMessage = showError || !!props.hint;

  const element =
    props.element === "input" ? (
      <input
        id={props.id}
        name={props.name || props.id}
        type={props.type}
        placeholder={props.placeholder}
        autoComplete={props.autoComplete}
        required={props.required}
        aria-invalid={showError}
        aria-describedby={hasMessage ? messageId : undefined}
        onChange={changeHandler}
        onBlur={touchHandler}
        value={inputState.value}
      />
    ) : (
      <textarea
        id={props.id}
        name={props.name || props.id}
        rows={props.rows || 3}
        aria-invalid={showError}
        aria-describedby={hasMessage ? messageId : undefined}
        onChange={changeHandler}
        onBlur={touchHandler}
        value={inputState.value}
      />
    );
  return (
    <div className={`form-control ${showError ? "form-control--invalid" : ""}`}>
      <label htmlFor={props.id}>{props.label}</label>
      {element}
      {showError && <p id={messageId}>{props.errorText}</p>}
      {!showError && props.hint && (
        <p id={messageId} className="form-control__hint">{props.hint}</p>
      )}
    </div>
  );
};

export default Input;